import { createFileRoute } from '@tanstack/react-router';

function ClientHome() {
  return (
    <main className="mx-auto max-w-3xl p-8">
      <h1 className="text-2xl font-semibold">EURECA Client</h1>
      <p className="mt-2 text-muted-foreground">
        Hiring oversight surface for company stakeholders. Review job opportunities, approve
        shortlists, and monitor pipeline outcomes. Add review queues, approval screens, and hiring
        analytics as nested routes under <code>src/routes/</code>.
      </p>
    </main>
  );
}

export const Route = createFileRoute('/')({
  component: ClientHome,
});
